import React, { useEffect, useRef, useState } from 'react';
import './LoadingScreen.css'; // Ensure this CSS file contains the styling for the video

const LoadingScreen = ({ onVideoEnd }) => {
  const videoRef = useRef(null);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [theme, setTheme] = useState('light'); // Default to light theme

  useEffect(() => {
    const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)');
    
    // Set the theme based on user's preference
    setTheme(darkThemeMq.matches ? 'dark' : 'light');

    const videoElement = videoRef.current;

    // Ensure the video is loaded before starting playback
    const handleLoadedData = () => {
      if (videoElement) {
        videoElement.play().catch((error) => {
          console.error("Error during video playback:", error);
        });
      }
    };

    const handleEnded = () => {
      setIsFadingOut(true); // Start fading out when video ends
      setTimeout(onVideoEnd, 1000); // Wait for fade-out duration before calling onVideoEnd
    };

    if (videoElement) {
      videoElement.addEventListener('loadeddata', handleLoadedData);
      videoElement.addEventListener('ended', handleEnded);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('loadeddata', handleLoadedData);
        videoElement.removeEventListener('ended', handleEnded);
      }
    };
  }, [onVideoEnd]);

  return (
    <div className={`video-container ${isFadingOut ? 'fade-out' : ''}`}>
      <video
        ref={videoRef}
        src={`${process.env.PUBLIC_URL}/videos/${theme === 'dark' ? 'Eye_Loading2.mp4' : 'Eye_Loading2copy.mp4'}`}
        className="fullscreen-video"
        muted
        playsInline // Ensures compatibility with mobile browsers
      />
    </div>
  );
};

export default LoadingScreen;
